export enum DragAndDropFileTypesEnum {
  CSV = 'text/csv',
  JSON = 'application/json',
}

export const DragAndDropFileTypesToAccept: {[key in DragAndDropFileTypesEnum]: string} = {
  [DragAndDropFileTypesEnum.CSV]: '.csv, text/csv',
  [DragAndDropFileTypesEnum.JSON]: '.json, application/json',
};

export enum DragAndDropVersionsEnum {
  V1 = 'V1',
  V2 = 'V2',
}
